import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sanityClient from "../client.js";
import SanityBlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";


const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function Post() {
  const [postData, setPost] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "post"] | order(publishedAt desc){
        title,
        slug,
        mainImage{
          asset->{
            _id,
            url
          },
          crop,
          hotspot,
          alt
        },
        abstract,
        publishedAt
      }`)
      .then((data) => { setPost(data); console.log(data) })
      .catch(console.error);
  }, []);

  return (
    <div className="posts-body">
      <main>
        <section>
          <div className="grid-container">
            <div className="post-grid">
              {postData && postData.map((post, index) => (
                <article className="post-card" key={index}>
                  <Link to={"/posts/" + post.slug.current} key={post.slug.current}>
                    <div className="blogcard-image-container">
                      <img
                        src={urlFor(post.mainImage).width(800).url()}
                        alt={post.mainImage.alt}
                        className="post-thumbnail"
                      />
                    </div>
                    <div className="blogcard-content">
                      <h3 className="blogcard-title">{post.title}</h3>
                      <div className="blogcard-abstract">
                        <SanityBlockContent
                          blocks={post.abstract}
                          projectId="066s3bew"
                          dataset="production"
                        />
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}